/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DtcoActivity {
    DRIVE = 'drive',
    WORK = 'work',
    REST = 'rest',
    AVAILABLE = 'available',
    ERROR = 'error',
}
